import { render, staticRenderFns } from "./ReturnExpand.vue?vue&type=template&id=12b1a824&"
import script from "./ReturnExpand.vue?vue&type=script&lang=js&"
export * from "./ReturnExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports